import { callWithAuth } from '@/services/auth/call-with-auth'
import { SmsAuthService } from '@/services/auth/sms-auth'
import { AlreadyUsedTelError } from '@spa/components/pages/auth/error/already-used-tel-error'
import {
  ExceedSmsCodeAuthTrialTimesError
} from '@spa/components/pages/auth/error/exceed-sms-code-auth-trial-times-error'
import { SignupError } from '@spa/components/pages/auth/error/signup-error'

export interface SmsAuthRepository {
  startSmsAuthBy(tel: string): Promise<void>
  resendToken(): Promise<void>
  authenticate(token: string): Promise<void>
}

export class DefaultSmsAuthRepository implements SmsAuthRepository {
  constructor(
    private readonly updateTel: (tel: string) => Promise<void>,
    private readonly smsAuthService: SmsAuthService
  ) {}

  async startSmsAuthBy(tel: string): Promise<void> {
    return await callWithAuth(async () => {
      /*
       * 電話番号更新 → トークン請求をまとめて実行するFront APIを定義したら、
       * それを呼び出すかたちに変更する
       */
      await this.updateTel(tel)
      await this.requestAuthToken()
    })
  }

  async resendToken(): Promise<void> {
    await this.requestAuthToken()
  }

  async authenticate(token: string): Promise<void> {
    const response = await this.smsAuthService.authenticate(token)

    if (response.isLeft()) {
      if (hasExceedMaxCodeAuthTrialTimesError(response.value)) {
        throw new ExceedSmsCodeAuthTrialTimesError(
          response.value.message,
          'コードが間違っています。コード入力回数の上限に達したので、もう一度電話番号の入力からやり直してください。'
        )
      }

      throw new SignupError(
        response.value.message,
        'コードが間違っています。'
      )
    }
  }

  private async requestAuthToken(): Promise<void> {
    const response = await this.smsAuthService.sendAuthToken()

    if (response.isLeft()) {
      if (hasAlreadyUsedTelNumberError(response.value)) {
        throw new AlreadyUsedTelError('The phone number is already used by other user.')
      }

      throw new SignupError(
        response.value.message,
        'SMS認証コードを送信できませんでした。'
      )
    }

    return
  }
}

const hasAlreadyUsedTelNumberError = (e: any): boolean => {
  return e.response
      && e.response.body
      // tslint:disable-next-line: no-magic-numbers
      && e.response.body['reason.code'] === 2412
}

/**
 * TODO: コード認証を規定上限回数以上間違えた場合の正しい reason.code に変更
 * FIXME: 1234 はダミー
 */
const hasExceedMaxCodeAuthTrialTimesError = (e: any): boolean => {
  return e.response
      && e.response.body
      // tslint:disable-next-line: no-magic-numbers
      && e.response.body['reason.code'] === 1234
}
